import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import curved9 from "assets/images/preview.png";
import toast from "react-hot-toast";
import { baseURL } from "utils/api";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";

function SignIn() {
  
 
  const userTheme = useSelector((state) => state.commonSlice.theme);
  const [rememberMe, setRememberMe] = useState(true);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberMeEmail");
    const savedPassword = localStorage.getItem("rememberMePassword");
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (rememberMe) {
      localStorage.setItem("rememberMeEmail", email);
      localStorage.setItem("rememberMePassword", password);
    } else {
      localStorage.removeItem("rememberMeEmail");
      localStorage.removeItem("rememberMePassword");
    }
    e.preventDefault();

    if (!email) {
      return toast.error("Please enter email & password");
    }
    if (!password) {
      return toast.error("Password is required");
    }


    fetch(`${baseURL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          toast.success(data.message);
          localStorage.setItem("token", data?.token);
          localStorage.setItem("id", data?.data?._id);
          navigate("/dashboard");
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        toast.error(err.message || 'Something went wrong');;
      });
  };



  const handlePasswordToggle = () => {
    setShowPassword((prev) => !prev);
  };


  return (
    <CoverLayout
      title="Welcome back"
      description="Enter your email and password to sign in"
      image={curved9}
      forgot={false}
    >
      <SoftBox>
        <SoftBox component="form" role="form" onSubmit={handleSubmit}>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Email
              </SoftTypography>
            </SoftBox>
            <SoftInput
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="Email"
            />
          </SoftBox>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Password
              </SoftTypography>
            </SoftBox>
            <div style={{ position: "relative" }}>
              <SoftInput
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
              />
              <div
                onClick={handlePasswordToggle}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "60%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: userTheme === 'dark' ? 'white' : 'black'
                }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </div>
            </div>
          </SoftBox>
          <SoftBox mb={2} display="flex" justifyContent="space-between">
            <SoftBox display="flex" alignItems="center">

              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <SoftTypography
                variant="button"
                fontWeight="regular"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none" }}
              >
                &nbsp;&nbsp;Remember me
              </SoftTypography>
            </SoftBox>
            <SoftTypography
              component={Link}
              to="/forgot-password"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Forgot password?
            </SoftTypography>
          </SoftBox>
          <SoftBox mt={4} mb={1}></SoftBox>
          <SoftButton type="submit" variant="gradient" color="info" fullWidth>
            sign in
          </SoftButton>
        </SoftBox>
        <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button"
            sx={{
              color: userTheme === 'dark' ? 'white' : 'black'
            }}
            fontWeight="regular"> Don&apos;t have an account?{" "}</SoftTypography>
          <SoftTypography
            component={Link}
            to="/register"
            variant="button"
            color="info"
            fontWeight="medium"
            textGradient
          >
            Sign up
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
